import StationActivityContainer from '@/containers/admin/StationActivityContainer';
import EmailDashboardContainer from '@/containers/admin/EmailDashboardContainer';
import EmailComposerContainer from '@/containers/admin/EmailComposerContainer';

export default [
  {
    path: '/admin/stationActivity',
    name: 'StationActivity',
    meta: { requiresAuth: true, is_staff: true },
    component: StationActivityContainer,
  },
  {
    path: '/admin/templates',
    name: 'EmailDashboard',
    meta: { requiresAuth: true, is_staff: true },
    component: EmailDashboardContainer,
  },
  {
    path: '/admin/templates/:id',
    name: 'EmailComposer',
    meta: { requiresAuth: true, is_staff: true },
    component: EmailComposerContainer,
  },
];



// WEBPACK FOOTER //
// ./src/router/admin.js